import { useEffect, useState } from 'react'
import { useAtomValue, useSetAtom } from 'jotai'

import * as fetchs from '../fetchs'
import * as lib from '../lib'
import * as state from '../states'
import { ITokensState } from '../types'
import { IFetchItemsSetup, INoFetch } from '../types'
import { IFetchItems, IOffer } from '../types'
import { ESortOrder } from '../components'

type IUseOfferList = {
	error: INoFetch | null;
	items: IOffer[];
	total: number;
	warmUp: () => void;
}

export function useOfferList(
	setup: IFetchItemsSetup,
	send: boolean
): IUseOfferList {
	const tokens: ITokensState = useAtomValue(state.tokensAtom)
	const setFetchIsLoading = useSetAtom(state.fetchIsLoadingAtom)

	const [error, setError] = useState<INoFetch | null>(null)
	const [items, setItems] = useState<Array<IOffer>>([])
	const [total, setTotal] = useState<number>(0)
	const [warmUpIt, setWarmUpIt] = useState<number>(0)

	//console.log('hook.useOfferList:: START:: ', {filter: setup?.filter})
	const filter = lib.filterSetup([...setup?.filter ?? []])
	const sort = lib.sortSetup([...setup?.sort ?? []])
	const skip = lib.skipSetup(setup?.skip)
	const take = lib.takeSetup(setup?.take)
	const access = tokens?.access ?? null
	const warmUp = () => setWarmUpIt(warmUpIt + 1)

	useEffect(() => {
		const controller = new AbortController()
		const signal = controller.signal

		const call = async () => {
			try {
				setFetchIsLoading(state.turnOnLoader)
				const res = await fetchs.listOffer(filter, sort, skip, take, signal, access)
				const { items, total }: IFetchItems<IOffer> = res
				setError(null)
				setItems(items)
				setTotal(total)
			} catch (error: unknown) {
				setError(error as INoFetch)
				setItems([])
				setTotal(0)
			} finally {
				setFetchIsLoading(state.turnOffLoader)
			}
		}
		send && call()
		return () => {
			controller.abort()
		}
	}, [
		send,
		warmUpIt,
		filter, sort,
		skip, take,
		access
	])
	return { error, items, total, warmUp }
}
